<app-ehe-header [auth]="true" [wellness]="true" [healthHistory]="true"></app-ehe-header>
<section class="">
	<div class="new-ha-wrapper" id="new-ha">
		<div class="strip">
			<div class="ha-head-content">
				<div class="ha-heading">ANNUAL PREVENTIVE EXAM</div>
				<div class="name" *ngIf="profileService.getFirstName().value">
					{{ profileService.getFirstName().value }}'s Health Assessment
				</div>
				<!-- <div class="hide">Last updated on January 29,2021</div> -->
			</div>
		</div>

		<div class="ha-banner" *ngIf="showBanner">
			<div class="title" [translate]="'wellness.health-assessment-new.banner.title'">
				Thank you for completing the Health Assessment!
			</div>
			<div class="content" [translate]="'wellness.health-assessment-new.banner.content'">
				Your Health Assessment is not able to be edited or updated at this time, but please let your physician know of
				any additional details during your appointment. The EHE Health team is looking forward to seeing you soon!
			</div>
			<div class="image"></div>
		</div>

		<div class="read-only-strip" *ngIf="readOnly">
			<div class="ha-head-content">
				<div [translate]="'wellness.health-assessment-new.banner.read-only'">
					Your health assessment is view-only until your next preventive health exam appointment.
				</div>
				<a
					class="book-appt"
					[routerLink]="['/scheduling/create/appointment']"
					[translate]="'wellness.health-assessment-new.banner.schedule-appt'"
					>Schedule your next appointment.</a
				>
			</div>
		</div>

		<div class="ha-section" id="mat-stepper">
			<mat-vertical-stepper [linear]="false" #stepper (selectionChange)="selectEvent($event)">
				<ng-template matStepperIcon="done">
					<mat-icon>done</mat-icon>
				</ng-template>
				<ng-template matStepperIcon="dot">
					<mat-icon>fiber_manual_record</mat-icon>
				</ng-template>
				<ng-template matStepperIcon="edit">
					<mat-icon>edit</mat-icon>
				</ng-template>

				<mat-step state="dot">
					<ng-template matStepLabel>
						<div
							routerLinkActive="active"
							[routerLink]="[
								{
									outlets: {
										general: ['personal-info'],
										medical: null,
										lifestyle: null
									}
								}
							]"
							[queryParams]="{
								apptID: apptID,
								readOnly: readOnly,
								healthAssessmentID: healthAssessmentID,
								section: '',
								returningUser: returningUser
							}"
							skipLocationChange>
							General Information
						</div>
						<div class="sub-section">
							<ul class="{{ readOnly ? 'read-only' : !returningUser && !showBanner ? 'read-only new-user' : '' }}">
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												general: ['personal-info'],
												medical: null,
												lifestyle: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: '',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a pageScroll href="#general-personal-info">Personal Information,</a>
								</li>
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												general: ['personal-info'],
												medical: null,
												lifestyle: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'general-emergency',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a  pageScroll [pageScrollOffset]=100 href="#general-emergency">Emergency Contact,</a>
								</li>
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												general: ['personal-info'],
												medical: null,
												lifestyle: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'general-livingwill',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a pageScroll href="#general-livingwill">Living Will,</a>
								</li>
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												general: ['primary-care'],
												medical: null,
												lifestyle: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'general-primarycare',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a pageScroll href="#general-primarycare"> Primary Care Physician,</a>
								</li>
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												general: ['primary-care'],
												medical: null,
												lifestyle: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'general-specialists',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a pageScroll href="#general-specialists">Specialists</a>
								</li>
							</ul>
						</div>
					</ng-template>
					<div class="section-info">
						<!-- <app-ha-general-info  [readOnly]="readOnly" [apptID]="apptID" [healthAssessmentID]="healthAssessmentID"></app-ha-general-info> -->
						<router-outlet name="general"></router-outlet>
					</div>
				</mat-step>

				<mat-step state="dot">
					<ng-template matStepLabel>
						<div
							routerLinkActive="active"
							[routerLink]="[
								{
									outlets: {
										medical: ['medical-condition'],
										general: null,
										lifestyle: null
									}
								}
							]"
							[queryParams]="{
								apptID: apptID,
								readOnly: readOnly,
								healthAssessmentID: healthAssessmentID,
								section: 'medical-medical-condition',
								returningUser: returningUser
							}"
							skipLocationChange>
							Medical History
						</div>
						<div class="ha-medical-new">
							<!-- <div class="section-title">Medical History</div> -->
							<ul class="{{ readOnly ? 'read-only' : !returningUser && !showBanner ? 'read-only new-user' : '' }}">
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												medical: ['medical-condition'],
												general: null,
												lifestyle: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'medical-medical-condition',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a pageScroll href="#medical-medical-condition">Medical Conditions,</a>
								</li>
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												medical: ['medical-condition'],
												general: null,
												lifestyle: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'medical-surgical-history',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a pageScroll href="#medical-surgical-history">Surgical History,</a>
								</li>
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												medical: ['medical-condition'],
												general: null,
												lifestyle: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'medical-medications',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a pageScroll href="#medical-medications">Medications,</a>
								</li>
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												medical: ['medical-condition'],
												general: null,
												lifestyle: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'medical-allergies',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a pageScroll href="#medical-allergies">Allergies,</a>
								</li>
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												medical: ['screening'],
												general: null,
												lifestyle: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'medical-screening',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a  pageScroll [pageScrollOffset]=100 href="#medical-screening">Screenings,</a>
								</li>
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												medical: ['screening'],
												general: null,
												lifestyle: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'medical-vaccination',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a pageScroll href="#medical-vaccination">Vaccinations,</a>
								</li>
								<li
									routerLinkActive="active"
									*ngIf="profileService.getGender().value === 'MALE'"
									[routerLink]="[
										{
											outlets: {
												medical: ['men-health'],
												general: null,
												lifestyle: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'medical-men-health',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a  pageScroll [pageScrollOffset]=20 href="#medical-men-health">Men's Health,</a>
								</li>
								<li
									routerLinkActive="active"
									*ngIf="profileService.getGender().value === 'FEMALE'"
									[routerLink]="[
										{
											outlets: {
												medical: ['women-health'],
												general: null,
												lifestyle: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'medical-women-health',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a  pageScroll [pageScrollOffset]=20 href="#medical-women-health">Women's Health,</a>
								</li>
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												medical: ['family-history'],
												general: null,
												lifestyle: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'medical-family-history',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a pageScroll href="#medical-family-history">Family History</a>
								</li>
							</ul>
						</div>
					</ng-template>
					<div class="section-info">
						<router-outlet name="medical"></router-outlet>
					</div>
				</mat-step>

				<mat-step state="dot">
					<ng-template matStepLabel>
						<div
							routerLinkActive="active"
							[routerLink]="[
								{
									outlets: {
										lifestyle: ['health-goals'],
										general: null,
										medical: null
									}
								}
							]"
							[queryParams]="{
								apptID: apptID,
								readOnly: readOnly,
								healthAssessmentID: healthAssessmentID,
								section: 'lifestyle-health-goals',
								returningUser: returningUser
							}"
							skipLocationChange>
							Lifestyle
						</div>
						<div class="ha-lifestyle-new">
							<!-- <div class="section-title">Lifestyle</div> -->
							<ul class="{{ readOnly ? 'read-only' : !returningUser && !showBanner ? 'read-only new-user' : '' }}">
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												lifestyle: ['health-goals'],
												general: null,
												medical: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'lifestyle-health-goals',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a pageScroll href="#lifestyle-health-goals">Health Goals, </a>
								</li>
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												lifestyle: ['how-you-eat'],
												general: null,
												medical: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'lifestyle-how-you-eat',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a pageScroll href="#lifestyle-how-you-eat">How You Eat, </a>
								</li>
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												lifestyle: ['how-you-move'],
												general: null,
												medical: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'lifestyle-how-you-move',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a pageScroll href="#lifestyle-how-you-move">How You Move, </a>
								</li>
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												lifestyle: ['how-you-think'],
												general: null,
												medical: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'lifestyle-how-you-think',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a pageScroll href="#lifestyle-how-you-think">How You Think, </a>
								</li>
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												lifestyle: ['work-life-balance'],
												general: null,
												medical: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'lifestyle-work-life-balance',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a  pageScroll [pageScrollOffset]=20 href="#lifestyle-work-life-balance">Work/Life Balance, </a>
								</li>
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												lifestyle: ['how-you-sleep'],
												general: null,
												medical: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'lifestyle-how-you-sleep',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a pageScroll href="#lifestyle-how-you-sleep">How You Sleep, </a>
								</li>
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												lifestyle: ['substance-abuse'],
												general: null,
												medical: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'lifestyle-substance-abuse',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a pageScroll href="#lifestyle-substance-abuse">Substance Abuse, </a>
								</li>
								<li
									routerLinkActive="active"
									[routerLink]="[
										{
											outlets: {
												lifestyle: ['safety'],
												general: null,
												medical: null
											}
										}
									]"
									[queryParams]="{
										apptID: apptID,
										readOnly: readOnly,
										healthAssessmentID: healthAssessmentID,
										section: 'lifestyle-safety',
										returningUser: returningUser
									}"
									skipLocationChange>
									<a pageScroll href="#lifestyle-safety">Safety </a>
								</li>
							</ul>
						</div>
					</ng-template>
					<div class="section-info">
						<router-outlet name="lifestyle"></router-outlet>
					</div>
				</mat-step>
			</mat-vertical-stepper>
		</div>
	</div>
</section>
<app-ehe-spinner></app-ehe-spinner>
<app-ehe-footer [socialNetwork]="true"></app-ehe-footer>
